module.exports = __webpack_public_path__ + "img/0220805141349.2d299b3f.jpg";